import { AxiosResponse } from 'axios';

import { TRANSACTION_FILTERS, TRANSACTION_TYPE } from '../../types';

import { PaginationResponse } from './dto/BaseApi';
import {
  TransactionHistoryResponse,
  TransactionHistorySearch,
} from './dto/Transactions';
import BaseApi from './BaseApi';

const transactionsApi = {
  getLastTypeTransactions(
    token: string,
    payload: {
      accountId: number;
      type: TRANSACTION_TYPE;
      count: number;
    }
  ): Promise<AxiosResponse<TransactionHistoryResponse[]>> {
    return BaseApi.get(
      `/api/v1/transactions/last?accountId=${payload.accountId}&count=${
        payload.count
      }${payload.type ? `&type=${payload.type}` : ''}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getSearchTransactions(
    token: string,
    filters: TRANSACTION_FILTERS
  ): Promise<AxiosResponse<PaginationResponse<TransactionHistorySearch[]>>> {
    return BaseApi.post('/api/v1/transactions/search', filters, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getTransaction(payload: {
    accountId: number;
    transactionId: number;
  }): Promise<AxiosResponse<any>> {
    return BaseApi.get(
      `/api/v1/transactions/details?transactionId=${payload.transactionId}&accountId=${payload.accountId}`
    );
  },
};

export default transactionsApi;
